/* file description */
import { Modal, Input, Tooltip, Button, Select, message, Collapse, Table } from 'antd';
import { SearchOutlined, CopyOutlined } from '@ant-design/icons';
import React, { FC, useEffect, useState, useRef } from 'react';
import SPTableWithModel from '@/components/SPTableWithModel';
import { SPTableBaseMode } from '@/components/SPTableBase/effect';
import { getApiData, getDataPosition, getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { useTargetTableColumns, useLinShowModalSelect, useSetLabel, useGetLabelByEdit, useSetFilter, useFetchData, useGetAdvice } from './effect';
import copy from 'copy-to-clipboard';
import { COLUMN_FROM } from '../../effects/consts';
import { RecordSelectLinkShowModalProps } from './type';
import { BoxLayout } from './Layout';
import styles from './index.module.less';
import memo from '../memo';
import { cloneDeep } from 'lodash';
import { ModalFullLayout } from '@/asset/AssetTask/templates/Cascade/components';

const { Search } = Input;
const { Panel } = Collapse;

export const RecordSelectLinkShowModal: FC<RecordSelectLinkShowModalProps> = ({
  API,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  storeValue,
  rowsData,
  disabled,
  isMobile,
  allowClear,
  moduleInfo,
  ...otherPorps
}) => {
  const { dispatchEvent, destroyEvent, taskInfo } = config.metaStore || {};
  const [apiParamsList, setapiParamsList] = useState({});
  const [status, setStatus] = useState<any>('');
  const [existVal, setExistVal] = useState<boolean>(true);
  const [copyIcon, setCopyIcon] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const paramsRef = useRef<Record<any, any>>({});
  const [defaultCurrent, setDefaultCurrent] = useState<Number>(1);
  const apiRef = useRef({});
  const { dataKey, treeId, value: fieldName, canAdd, addPageId, labelBindLabel, isBindLabel, preSort, isMulti, isOpenApi, apiUrl, apiKeyList, options = [], isFilter, dataType, prefilter, isOpenAdvice } = field?.options || {};
  // 回显值设置
  const { showLabel, setShowLabel, optionList, setOptionList } = useSetLabel();
  // filter过滤处理
  const { filter } = useSetFilter({ field, form, config, columnFrom, setShowLabel, setOptionList, onChange, fieldValue: value, rowsData, moduleInfo, dataKey, treeId, API, isMulti });
  // selected选择控制
  const SelectedRef = useRef<Record<any, any> | null>(null);
  // 交互处理
  const { linkShowModalContrulor, showLinkShowModal, onSelectChange, onModalEnter, setInputLabel, selectedRowKeys, setSelectedRowKeys, clickRow } =
  useLinShowModalSelect({ setShowLabel, API, isMulti, setOptionList, moduleInfo, SelectedRef });
  // 编辑时回显值处理
  useGetLabelByEdit({ value, field, form, config, columnFrom, setInputLabel, API, setExistVal, setSelectedRowKeys });
  // column的处理
  const { targetTableColumns } = useTargetTableColumns({ field });
  // 远程搜索处理
  const { handleSearch } = useFetchData({ setOptionList, API, field, filter, setSearchValue });
  // 推荐列表展示
  const { adviceList, adviceTableColumn } = useGetAdvice({ field, API, config, storeValue, columnFrom, onChange });

  // let fieldError: any[];
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   const tableValid = form.getFieldsError().find((item: any) => item.name[0] === config.rowIndex && item.name[1] === field.name);
  //   fieldError = tableValid?.errors || [];
  // } else {
  //   fieldError = form.getFieldError(field.name);
  // }

  // const apiParamsList: Record<any, any> = {};
  // let headData: Record<any, any> = {};
  // if (storeValue) {
  //   Object.keys(storeValue).forEach((key: any) => {
  //     if (!Array.isArray(storeValue[key])) {
  //       headData = storeValue[key];
  //     }
  //   });
  // }

  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   if (rowsData?.[config.rowIndex]) {
  //     // if (form.getFieldsValue()[config.rowIndex]) {
  //     if (isOpenApi) {
  //       apiKeyList.forEach((item: any) => {
  //         if (item.isValueFromMainModule) {
  //           apiParamsList[item.apiKey] = headData?.[item.apiValueModule];
  //         } else {
  //           apiParamsList[item.apiKey] = rowsData?.[config.rowIndex]?.[item.apiValue];
  //           // apiParamsList[item.apiKey] = form.getFieldsValue()[config.rowIndex][item.apiValue];
  //         }
  //       });
  //     }
  //   }
  // }
  // if (columnFrom === COLUMN_FROM.FORM) {
  //   if (isOpenApi) {
  //     apiKeyList.forEach((item: any) => {
  //       if (item.isValueFromMainModule) {
  //         apiParamsList[item.apiKey] = headData?.[item.apiValueModule];
  //       } else {
  //         apiParamsList[item.apiKey] = form.getFieldsValue()[item.apiValue];
  //       }
  //     });
  //   }
  // }
  useEffect(() => {
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    if (columnFrom === COLUMN_FROM.TABLE) {
      if (rowsData?.[config.rowIndex]) {
        if (isOpenApi) {
          apiKeyList?.forEach((item: any) => {
            if (item.isValueFromMainModule) {
              apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
            } else {
              apiRef.current = { ...apiRef.current, [item.apiKey]: rowsData?.[config.rowIndex]?.[item.apiValue] };
            }
          });
        }
      }
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      if (isOpenApi) {
        apiKeyList?.forEach((item: any) => {
          if (item.isValueFromMainModule) {
            apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
          } else {
            apiRef.current = { ...apiRef.current, [item.apiKey]: config.formValue[item.apiValue] };
          }
        });
      }
    }

    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const idList: any[] = [];
    if (isOpenApi) {
      apiKeyList?.forEach((item: any) => {
        const events = [{
          code: field.name,
          name: field.label,
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: item.isValueFromMainModule ? mainModuleCode : moduleInfo.handle,
          fieldName: item.isValueFromMainModule ? item.apiValueModule : item.apiValue,
          rowIndex: config.rowIndex,
          fun: (value: any) => {
            apiRef.current = { ...apiRef.current, [item.apiKey]: value };
            setapiParamsList({ ...apiRef.current, [item.apiKey]: value });
          },
        }];
        const ids = dispatchEvent?.(events);
        idList.push(ids);
      });
    }
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  // useEffect(() => {
  //   if (fieldError?.length > 0 || !existVal) {
  //     setStatus('error');
  //   } else {
  //     setStatus('');
  //   }
  // }, [fieldError]);

  useEffect(() => {
    if (isOpenApi) {
      getApiData(API?.FetchAPI, apiUrl, apiRef.current).then((res: any) => {
        const { set = [] } = res || {};
        const mapData = set.map((item: any) => {
          const converData = convert(item);
          return converData;
        });
        // 组件在table里时，apiParamsList会多触发一次, 可能会覆盖数据。在form里正常
        if (JSON.stringify(apiRef.current) !== '{}') {
          setTimeout(() => {
            setTableData(mapData);
            if (mapData?.length === 1 && !isMulti) {
              options.forEach((item: { moduleField: any; linkField: any }) => {
                const values: Record<any, any> = {};
                if (columnFrom === COLUMN_FROM.FORM) {
                  values[item.moduleField] = mapData[0]?.[item.linkField];
                  form.setFieldsValue(values);
                }
                if (columnFrom === COLUMN_FROM.TABLE) {
                  const tableKey = config.rowIndex;
                  values[tableKey] = {};
                  values[tableKey][item.moduleField] = mapData[0]?.[item.linkField];
                  form.setFieldsValue(values);
                }
              });
              onChange?.(mapData[0][fieldName]);
            }
          }, 100);
        } else {
          setTableData(mapData);
          if (mapData?.length === 1 && !isMulti) {
            options.forEach((item: { moduleField: any; linkField: any }) => {
              const values: Record<any, any> = {};
              if (columnFrom === COLUMN_FROM.FORM) {
                values[item.moduleField] = mapData[0]?.[item.linkField];
                form.setFieldsValue(values);
              }
              if (columnFrom === COLUMN_FROM.TABLE) {
                const tableKey = config.rowIndex;
                values[tableKey] = {};
                values[tableKey][item.moduleField] = mapData[0]?.[item.linkField];
                form.setFieldsValue(values);
              }
            });
            onChange?.(mapData[0][fieldName]);
          }
        }
      });
    }
  }, [JSON.stringify(apiRef.current)]);

  const copyName = () => {
    const label = isBindLabel ? (labelBindLabel || field?.options?.value) : field?.options?.label;
    const findDict = optionList.find((item: any) => item[field?.options?.value] === value) || {};
    copy(findDict?.[label] || value);
    message.success('复制成功');
  };

  const getDefaultCurrent = () => {
    if (value) {
      // let defaultFilter = '';
      // if (isFilter) {
      //   defaultFilter = dataType || prefilter || '';
      // }
      getDataPosition(API?.FetchAPI, {
        filter,
        sort: preSort || '',
        namespaceId: treeId,
        modelId: dataKey,
        limit: 10,
        positionKey: fieldName,
        positionValue: value,
      }).then((res: any) => {
        setDefaultCurrent(res?.pageNum || 1);
        linkShowModalContrulor(true);
      });
    } else {
      setDefaultCurrent(1);
      linkShowModalContrulor(true);
    }
  };

  const showContent = () => {
    if (searchValue) {
      return '结果无匹配';
    }
    return '请点击放大镜或直接录入搜索';
  };
  // 从复制页面过来的 联动字段更新
  const setShowFieldsValue: SetShowFieldsValue = async ({ form, field, columnFrom, config, type }) => {
    if (isMulti) {
      return;
    }
    const { emitEvent } = config.metaStore || {};
    const { showFields = [], options = [] } = field.options || {};
    // 是否是从复制页面过来的数据
    let isFormCopyValue = false;
    if (!SelectedRef.current) {
      isFormCopyValue = true;
      const reqData = {
        page: 1,
        version: '0',
        namespaceID: treeId,
        moduleID: dataKey,
        filter: `${fieldName} in ('${value}')`,
        limit: 10,
        pageCursor: '',
        incPageNavigation: true,
        incTotal: true,
        sort: '',
      };
      const res = await getModuleRecordListCache(API.FetchAPI, treeId, dataKey, reqData);

      const newSelected: Record<string, any> = {};
      res?.set?.[0]?.values.forEach((valueItem) => {
        const { name = '', value = '' } = valueItem ?? {};
        newSelected[name] = value;
      });
      SelectedRef.current = newSelected;
    }

    // 联动保存字段
    options.forEach((item: { moduleField: any; linkField: any }) => {
      const values: Record<any, any> = {};
      if (columnFrom === COLUMN_FROM.FORM) {
        values[item.moduleField] = type === 'reset' ? '' : SelectedRef.current?.[item.linkField];
        form.setFieldsValue(values);
      }
      if (columnFrom === COLUMN_FROM.TABLE) {
        const tableKey = config.rowIndex;
        values[tableKey] = {};
        values[tableKey][item.moduleField] = type === 'reset' ? '' : SelectedRef.current?.[item.linkField];
        form.setFieldsValue(values);
      }
      emitEvent && emitEvent({ value: SelectedRef.current?.[item.linkField], moduleName: moduleInfo.handle, fieldName: item.moduleField, rowIndex: config.rowIndex, touchConfig: 'change', isFormCopyValue });
    });
  };
  useEffect(() => {
    // 选择时给联动字段赋值
    if (value) {
      setShowFieldsValue({ form, field, columnFrom, config, value });
    }
  }, [value, form, field, columnFrom, config]);

  return (
    <>
      {/* <Tooltip title="请点击右侧搜索按钮进行更改">
        <Search value={showLabel}
          onSearch={(val, e) => {
            if (e?.hasOwnProperty('type')) {
              linkShowModalContrulor(true)
            }
            else {
              onChange && onChange(null)
              setShowLabel('')
            }
          }}
          disabled={config.disabled || false}
          allowClear
        />
      </Tooltip> */}
      <div style={{ display: 'flex', minWidth: '100px', ...otherPorps?.style }}>
        <Select
          style={{ width: 'calc(100% - 32px)' }}
          status={status}
          showSearch
          showArrow={false}
          filterOption={false}
          onSearch={handleSearch}
          mode={isMulti ? 'multiple' : undefined}
          onChange={(val) => {
            const findDictItem = optionList?.find((item: Record<any, any>) => item[field?.options?.value] === val) || {};
            options.forEach((item: { moduleField: any; linkField: any }) => {
              const values: Record<any, any> = {};
              if (columnFrom === COLUMN_FROM.FORM) {
                values[item.moduleField] = findDictItem?.[item.linkField];
                form.setFieldsValue(values);
              }
              if (columnFrom === COLUMN_FROM.TABLE) {
                const tableKey = config.rowIndex;
                values[tableKey] = {};
                values[tableKey][item.moduleField] = findDictItem?.[item.linkField];
                form.setFieldsValue(values);
              }
            });
            onChange?.(val);
          }}
          notFoundContent={showContent()}
          value={value}
          options={optionList}
          onMouseEnter={() => {
            if (value) {
              setCopyIcon(true);
            }
          }}
          onMouseLeave={() => setCopyIcon(false)}
          fieldNames={{
            label: isBindLabel ? (labelBindLabel || field?.options?.value) : field?.options?.label,
            value: field?.options?.value,
          }}
          allowClear={allowClear !== false}
          disabled={disabled}
        />
        {
          copyIcon ?
            <div
              onMouseEnter={() => setCopyIcon(true)}
              className={styles.select_copy_icon}
              onClick={copyName}
            >
              <CopyOutlined style={{ color: '#999999' }} />
            </div> : ''
        }
        <Button
          onClick={() => {
            getDefaultCurrent();
          }}
          danger={status === 'error'}
          style={{ borderLeft: 'unset' }}
          icon={<SearchOutlined />}
          disabled={disabled}
        />
      </div>
      {
        isOpenAdvice ?
          <div className={styles.advice_content}>
            <Collapse>
              <Panel header="推荐结果" key="1">
                {
                  adviceList?.length > 0 ?
                    <Table
                      style={{ width: '100%' }}
                      rowKey={fieldName}
                      size="small"
                      bordered
                      pagination={false}
                      dataSource={adviceList}
                      columns={adviceTableColumn}
                    /> : <span>暂无推荐</span>
                }
              </Panel>
            </Collapse>
          </div> : ''
      }

      <ModalFullLayout
        // zIndex={9999}
        isMobile={isMobile}
        visible={showLinkShowModal}
        forceRender={columnFrom === COLUMN_FROM.FORM}
        onCancel={() => linkShowModalContrulor(false)}
        width={'70vw'}
        okText="确认选择"
        cancelText="取消"
        onOk={() =>
          onModalEnter({
            fieldName,
            onChange,
            form,
            config,
            field,
            columnFrom,
          })
        }
        style={isMobile ? { zIndex: 1500 } : {}}
      >
        <SPTableWithModel
          isMobile={isMobile}
          floadSearch
          rowSelection={{
            type: isMulti ? 'checkbox' : 'radio',
            selectedRowKeys,
            onChange: onSelectChange,
          }}
          // isNotMobile
          value={isOpenApi ? tableData : undefined}
          toolBarRender={
            canAdd ?
              <Button
                key="button"
                onClick={() => {
                  // window.open(addPageId);
                  const a = document.createElement('a');
                  a.setAttribute('href', addPageId);
                  a.setAttribute('target', '_blank');
                  a.setAttribute('id', 'LINKMODALHREF');
                  // 防止反复添加
                  if (document.getElementById('LINKMODALHREF')) {
                    document.body.removeChild(document.getElementById('LINKMODALHREF') as any);
                  }
                  document.body.appendChild(a);
                  a.click();
                }}
                type="primary"
              >
                新增
              </Button> : null
          }
          headerTitle={`请选择${field?.label}`}
          onRow={(record: any) => ({
            onClick: () => {
              clickRow(record._id, record);
              if (isMobile) {
                onModalEnter({
                  fieldName,
                  onChange,
                  form,
                  config,
                  field,
                  columnFrom,
                });
              }
            },
            onDoubleClick: () => onModalEnter({
              fieldName,
              onChange,
              form,
              config,
              field,
              columnFrom,
            }),
          })}
          onSearch={(searchParams: any) => {
            paramsRef.current = searchParams;
          }}
          onChange={(rowsAllData: any) => {
            if (Object.keys(paramsRef.current).length === 0) {
              if (rowsAllData?.length === 1 && !isMulti) {
                onChange?.(rowsAllData[0][fieldName]);
              }
            }
          }}
          requestParams={{
            sort: preSort || '',
          }}
          API={API}
          // rowKey={fieldName}
          moduleID={dataKey}
          namespaceID={treeId}
          filter={filter}
          columns={targetTableColumns}
          tableBaseMode={SPTableBaseMode.VIEW}
          defaultPagination={{
            current: defaultCurrent,
          }}
        />
      </ModalFullLayout>
    </>
  );
};
export default React.memo(RecordSelectLinkShowModal);
